const createPieChartFilterString = (label, index) => `${label}::${index}`;

export const getPieChartFilterValue = (previousIndex, nextIndex, nextLabel) => {
  const showAll = previousIndex === nextIndex;
  if (showAll) return null;

  return createPieChartFilterString(nextLabel, nextIndex);
};
